module.exports = __webpack_public_path__ + "img/sharePointIconLarge.b62b97f8.png";